import { useAtomValue } from "jotai";
import { AskHelenaShimmerLabel } from "shared/features/helenaV2/components/AskHelenaShimmerLabel";
import { askHelenaActiveTool, askHelenaStatus } from "../store";

/**
 * The in-flight indicator. Driven entirely by status — the answer text itself
 * only ever comes from `token` events.
 *
 * Renders nothing at all for a failed tool: `tool_result ok:false` is a normal
 * outcome that the prose answer explains, so it must not surface as a failure
 * indicator. Nothing either while the turn is suspended on an approval — the
 * card is the thing to look at, and a shimmer beside it would read as progress
 * that is not happening.
 */
export const AskHelenaStatusRow = () => {
  const status = useAtomValue(askHelenaStatus);
  const activeTool = useAtomValue(askHelenaActiveTool);

  if (
    status !== "thinking" &&
    status !== "tool_running" &&
    status !== "answering"
  )
    return null;

  // `activeTool` holds the service's own human phrase ("Checking the customer
  // list"), taken from `tool_call.label`. It is NOT derived from `name`: the
  // service went to real lengths to keep identifiers like
  // `deskday_list_customers` out of the model's context, and rebuilding one for
  // display puts it straight back on screen.
  const label =
    status === "answering"
      ? "Helena is typing..."
      : activeTool
        ? `${activeTool}...`
        : "Thinking...";

  return <AskHelenaShimmerLabel label={label} />;
};
